import { createFileRoute } from "@tanstack/react-router";
import { SignedIn } from "@/features/auth/signed-in";
import { SetupPage } from "@/features/setup/setup-page";
import { isSetupStep, type SetupStep } from "@/features/setup/steps";

export const Route = createFileRoute("/setup")({
  validateSearch: (search: Record<string, unknown>): { step?: SetupStep } =>
    isSetupStep(search.step) ? { step: search.step } : {},
  component: Page,
});

function Page() {
  const { step = "org" } = Route.useSearch();
  return (
    <SignedIn>
      <SetupPage step={step} />
    </SignedIn>
  );
}
